




/* Imports */
import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class TransitFacility extends Vue {}
